import classNames from 'classnames'
import React from 'react'
import Storage from '../../../npo-start-player-web/src/storage/storage'
import './tabs.scss'

/**
 * The props
 */
export interface TabsProps {
    /**
     * To specify the tabs
     */
    tabs: Array<{
        /**
         * The name of the tab
         */
        name: string

        /**
         * The content of the tab
         */
        content: JSX.Element
    }>
}

/**
 * The state
 */
export interface TabsState {
    /**
     * The selected tab
     */
    selectedTab: number
}

/**
 * Renders views conditionally based on the selected tab.
 * 
 * @author Stan Hurks
 */
export default class Tabs extends React.Component<TabsProps, TabsState> {
    constructor(props: TabsProps) {
        super(props)

        this.state = {
            selectedTab: Storage.data.wrapper.selectedTab
        }
    }
    
    public render = () => {
        return (
            <div className="tabs">
                <div className="tabs-tabs">
                    {
                        this.props.tabs.map((tab, tabIndex) => (
                            <div
                                className={classNames({
                                    'tabs-tabs-tab': true,
                                    'selected': tabIndex === this.state.selectedTab
                                })}
                                style={{
                                    width: `${100 / this.props.tabs.length}%`
                                }}
                                onClick={() => {
                                    Storage.data.wrapper.selectedTab = tabIndex
                                    
                                    this.setState({
                                        selectedTab: tabIndex
                                    })
                                }}
                                key={tabIndex}>
                                <div className="tabs-tabs-tab-label">
                                    { tab.name }
                                </div>
                            </div>
                        ))
                    }
                </div>
                <div className="tabs-content">
                    {
                        this.props.tabs[this.state.selectedTab]
                        &&
                        this.props.tabs[this.state.selectedTab].content
                    }
                </div>
            </div>
        )
    }
}